import React, { useState, useRef } from "react";
import axios from "axios";

const ImageUploader = () => {
  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [xOffset, setXOffset] = useState(0);
  const [yOffset, setYOffset] = useState(0);
  const [imageError, setImageError] = useState("");
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const canvasRef = useRef(null);
  const SQUARE_SIZE = 300; // Output size

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setImage(e.target.result);
      reader.readAsDataURL(file);
      setImageError("");
    } else {
      setImageError("Please select an image.");
    }
  };

  const uploadToCloudinary = async (blob) => {
    const formData = new FormData();
    formData.append("file", blob);
    formData.append("upload_preset", "checking"); // Cloudinary upload preset
    formData.append("folder", "ZOOM AUTOS");

    try {
      setUploading(true);
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/db2so7dyd/image/upload",
        formData
      );
      setUploading(false);
      return response.data.secure_url; // Return the uploaded image URL
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploading(false);
      return null;
    }
  };

  const handleUpload = async () => {
    if (!image) {
      setImageError("Please select an image first.");
      return null;
    }

    return new Promise((resolve) => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();

      img.onload = async () => {
        canvas.width = SQUARE_SIZE;
        canvas.height = SQUARE_SIZE;
        ctx.fillStyle = "white"; // Background color
        ctx.fillRect(0, 0, SQUARE_SIZE, SQUARE_SIZE);

        let scaleFactor = Math.min(
          SQUARE_SIZE / img.width,
          SQUARE_SIZE / img.height
        ) * scale;

        let newWidth = img.width * scaleFactor;
        let newHeight = img.height * scaleFactor;

        let adjustedX = (SQUARE_SIZE - newWidth) / 2 + xOffset;
        let adjustedY = (SQUARE_SIZE - newHeight) / 2 + yOffset;

        ctx.drawImage(img, adjustedX, adjustedY, newWidth, newHeight);

        canvas.toBlob(async (blob) => {
          if (blob) {
            const imageUrl = await uploadToCloudinary(blob);
            setUploadedImageUrl(imageUrl);
            resolve(imageUrl);
          } else {
            resolve(null);
          }
        }, "image/jpeg");
      };

      img.src = image;
    });
  };

  const handleSubmit = async () => {
    try {
      const imageUrl = await handleUpload();
      if (!imageUrl) {
        throw new Error("Image upload failed.");
      }

      const response = await axios.post("https://zoomautos.co.uk/api/Logos", {
        Image: imageUrl,
      });

      console.log("Logo uploaded successfully:", response.data);
      alert("Logo saved to database successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to save logo. Please try again.");
    }
  };

  return (
    <div className="overalls">
    <div className="mve-form" style={{ textAlign: "center" }}>
      <input type="file" accept="image/*" onChange={handleImageUpload} />
      {imageError && <p style={{ color: "red" }}>{imageError}</p>}
      <br />

      {image && (
        <>
          {/* Square Preview */}
          <div
            style={{
              width: SQUARE_SIZE,
              height: SQUARE_SIZE,
              border: "2px solid red",
              overflow: "hidden",
              margin: "20px auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "white",
            }}
          >
            <img
              src={image}
              alt="Uploaded"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                transform: `scale(${scale}) translate(${xOffset}px, ${yOffset}px)`,
              }}
            />
          </div>

          {/* Controls */}
          <label>Resize:</label>
          <input
            type="range"
            min="0.5"
            max="2"
            step="0.1"
            value={scale}
            onChange={(e) => setScale(parseFloat(e.target.value))}
          />
          <br />

          <label>Horizontal Position:</label>
          <input
            type="range"
            min="-100"
            max="100"
            step="1"
            value={xOffset}
            onChange={(e) => setXOffset(parseInt(e.target.value))}
          />
          <br />

          <label>Vertical Position:</label>
          <input
            type="range"
            min="-100"
            max="100"
            step="1"
            value={yOffset}
            onChange={(e) => setYOffset(parseInt(e.target.value))}
          />
          <br />

          <button onClick={handleSubmit} disabled={uploading}>
            {uploading ? "Uploading..." : "Upload & Save"}
          </button>

          {uploadedImageUrl && (
            <div>
              <p>Image Uploaded Successfully:</p>
              <a href={uploadedImageUrl} target="_blank" rel="noopener noreferrer">
                View Image
              </a>
            </div>
          )}

          {/* Hidden Canvas */}
          <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
        </>
      )}
    </div>
    </div>
  );
};

export default ImageUploader;
